module.exports = __webpack_public_path__ + "static/media/RafaelCastanedaFernandez.56cdf19a.jpg";